import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import themeReducer from "../Theme";
import languageReducer from "../Translate";
import { GetProfessionsSlice } from "../Professions/Professions.slice";
import { GetTelephoneCompaniesSlice } from "../TelephoneCompanies/TelephoneCompanies.slice";
import { AddPersonSlice } from "../Person/Person.slice";

const reducer = combineReducers({
  theme: themeReducer,
  language: languageReducer,
  professions: GetProfessionsSlice.reducer,
  telephoneCompanies: GetTelephoneCompaniesSlice.reducer,
  person: AddPersonSlice.reducer,
});

const store = configureStore({
  reducer,
});

export type State = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
